<ng-container #prefix></ng-container>
<div class="label">
  <ng-content></ng-content>
</div>
<ng-container #suffix></ng-container>
